<template>
  <b-modal
    class="deleteContractorModal"
    title="Delete Contractor"
    centered
    size="lg"
    ref="deleteContractorModal"
    ok-title="Confirm"
    cancel-title="Cancel"
    @open="open"
    @ok="handleOk"
  >
    <b-alert show variant="light"
      >Are you really gonna delete this contractor?</b-alert
    >
    <b-loading :loading="processing" />
  </b-modal>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      processing: false,
      initial: null,
    };
  },
  computed: {
    ...mapGetters(['error', 'loading']),
  },
  methods: {
    open(payload) {
      this.resetFormFields();
      this.initial = { ...payload };
      this.$refs.deleteContractorModal.show();
    },
    close() {
      this.$refs.deleteContractorModal.hide();
    },
    validate() {
      this.form.error.name = !this.form.name;
    },
    handleOk(e) {
      e.preventDefault();
      this.onSubmit();
    },
    onSubmit() {
      this.onSubmitForm();
    },
    onCancel() {
      this.close();
    },
    onReset() {
      this.resetFormFields();
    },
    resetFormFields() {
      this.initial = null;
      this.processing = false;
    },
    onSubmitForm(e) {
      e && e.preventDefault();
      if (this.initial && !this.processing && !this.loading) {
        this.processing = true;
        this.$store.dispatch('deleteContractor', this.initial).finally(() => {
          this.processing = false;
          this.close();
        });
      }
    },
  },
  created() {
    this.resetFormFields();
  },
};
</script>
<style>
.deleteContractorModal .modal-header {
  border-bottom: 0 none;
}
.deleteContractorModal .form-control {
  border: solid 1px #ccc;
}
.deleteContractorModal .form-actions .btn {
  min-width: 100px;
}
</style>
